import enLang from './entries/en_US';
import itLang from './entries/it_IT';

const AppLocale = {
  en: enLang,
  it: itLang,
};

export default AppLocale;
